import { cn } from '@/lib/cn';

/** A thin horizontal fill bar — the funnel, breakdown and challenge cards'
 * shared building block, styled from the mint tokens rather than a new color. */
export function ProgressBar({ pct, className }: { pct: number; className?: string }) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className={cn('bg-mint-tint-2 h-2 w-full overflow-hidden rounded-full', className)}>
      <div className="bg-mint h-full rounded-full" style={{ width: `${clamped}%` }} />
    </div>
  );
}
